import React, { useEffect, useState } from 'react';
import {
    Col,
    Row,
    Label,
    Input,
    Button,
    // FormFeedback
} from "reactstrap";
import Select from "react-select"
import axios from "axios";
import config from "../../../config";
import InputSpinner from "react-bootstrap-input-spinner";


const Type2 = (props) => {
    const { type2, setType2, formErrors, setFormErrors } = props
    const [stops, setStops] = useState([])
    const [selectStop, setSelectStop] = useState({
        label: '',
        value: ''
    })
    const [status, setStatus] = useState({
        shift_sl: false,
        stop_id: false
    })
    useEffect(() => {
        let arrayStops = [];
        const getStops = async () => {
            await axios.get(`${config.apiUrl}/stops`)
                .then(async (response) => {
                    for await (let item of response.data) {
                        let option = {}
                        option.label = item.name
                        option.value = item.id
                        arrayStops.push(option)

                        if (item.id === type2.stop_id) {
                            setSelectStop({
                                label: item.name,
                                value: item.id
                            })
                        }
                    }
                    setStops(arrayStops)
                })
                .catch(error => {
                    console.error(error);
                })
        }
        getStops()
    }, [type2.stop_id])

    useEffect(() => {
        if (type2.shiftStatus) setStatus({ ...status, shift_sl: true })
        if (type2.stopStatus) setStatus({ ...status, stop_id: true })
    }, [])

    // console.log(type2);

    const clearShift = () => {
        setStatus({ ...status, shift_sl: false })
        setType2({ ...type2, shift_sl: '' })
    }
    const clearStop = () => {
        setStatus({ ...status, stop_id: false })
        setType2({ ...type2, stop_id: '' })
        setSelectStop(null)
    }
    let errorItem;
    return (
        <>
            <Row>
                <Col>
                    <div className="d-flex align-items-center gap-3  mb-4">
                        <div className="border border-4 d-flex justify-content-center flex-shrink-0 align-items-center rounded-circle"
                            style={{ width: 50, height: 50 }}>
                            <i className="fas fa-info"></i>
                        </div>
                        <info_1 />
                        Тип Б) Стоп передвигается на определённый процент от изменения цены закрытия;
                    </div>
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={12} xl={4}>
                    <div className="mb-3">
                        <Label htmlFor="period">Разница Stop Price и Price, %</Label>
                        <InputSpinner
                        value={type2.delta_perc}
                        name="delta_perc"
                        type={"real"}
                        precision={1}
                        max={100}
                        min={0}
                        step={0.1}
                        onChange={(num) => {
                            setType2({ ...type2, delta_perc: num })
                            errorItem = formErrors;
                            delete errorItem.delta_perc;
                            setFormErrors(errorItem);
                        }}
                       />
                      <p style={{'fontSize':'10px','color': '#e06466'}}> {formErrors.delta_perc}</p>
                    </div>
                </Col>
                <Col xs={12} md={12} xl={8}>
                <Label htmlFor="period">Условие 1</Label>
                    <div className='d-flex align-items-center'>
                        <Input
                            type="checkbox"
                            className="form-check me-2"
                            placeholder='Введите процент...'
                            id='condition1'
                            disabled={type2.condition3 && true}
                            checked={type2.condition1}
                            onChange={() => setType2({ ...type2, condition1: !type2.condition1 })}
                        />
                        Stop не ниже изначального
                    </div>

                </Col>
                
            </Row>
            <Row>
                <Col xs={12} md={6} xl={4}>
                <div className="mb-3">
                        <Label htmlFor="period">Сдвиг цены, %</Label>
                        {/* <div className='d-flex justify-content-between'>
                            <div className='w-100' style={{ marginRight: 15 }}> */}
                        <InputSpinner
                            value={type2.shift_sl}
                            name="shift_sl"
                            type={"real"}
                            precision={1}
                            max={100}
                            min={0}
                            step={0.1}
                            onChange={(num) => {
                                setType2({ ...type2, shift_sl: num })
                                setStatus({ ...status, shift_sl: true })
                                errorItem = formErrors;
                                delete errorItem.shift_sl;
                                setFormErrors(errorItem);

                            }}                      
                        />     
                         <p style={{'fontSize':'10px','color': '#e06466'}}> {formErrors.shift_sl}</p>                          
                            {/* </div> */}
                            {/* кнопку закомментили, т.к. набор сдвигов не работает */}
                            {/* <Button
                                className='btn btn-danger'
                                disabled={status.stop_id && true}
                                onClick={clearShift}>
                                <i class="far fa-trash-alt"></i>
                            </Button> */}
                        {/* </div> */}
                    </div>                 

                </Col>
                <Col xs={12} md={6} xl={4}>
                    <div className="mb-3">
                        <Label htmlFor="period">Условие 2 (не ниже безубытка, в %):</Label>
                        <InputSpinner
                            value={type2.condition2}
                            name="condition2"
                            type={"real"}
                            precision={1}
                            max={100}
                            min={0}
                            step={0.1}
                            onChange={(num) => {
                                setType2({ ...type2, condition2: num })
                            }}
                        />  
                    
                    </div>
                </Col>
             
            </Row>
            <Row>
                <Col xs={12} md={6} xl={4}>
                    {/* Т.к. набор сдвигов пока не используем - закомментили */}
                {/* <div className="mb-3">
                        <Label htmlFor="period">Выбрать набор сдвигов, %</Label>
                        <div className='d-flex justify-content-between'>
                            <div className='w-100' style={{ marginRight: 15 }}>
                                <Select
                                    id='stop_id'
                                    placeholder="выбрать..."
                                    isDisabled={status.shift_sl && true}
                                    onChange={e => {
                                        setType2({ ...type2, stop_id: e.value })
                                        setStatus({ ...status, stop_id: true })
                                        setSelectStop({ label: e.label, value: e.value })
                                    }}
                                    options={stops}
                                    value={selectStop}
                                    classNamePrefix="select2-selection"
                                />
                            </div>
                            <Button
                                className='btn btn-danger'
                                disabled={status.shift_sl && true}
                                onClick={clearStop}>
                                <i class="far fa-trash-alt"></i>
                            </Button>
                        </div>
                    </div>                    */}
                </Col>
                <Col xs={12} md={6} xl={8}>
                <Label htmlFor="period">Условие 3</Label>
                    <div className='d-flex align-items-center'>
                        <Input
                            type="checkbox"
                            className="form-check me-2"
                            placeholder='Введите процент...'
                            id='condition3'
                            disabled={type2.condition1 && true}
                            checked={type2.condition3}
                            onChange={() => setType2({ ...type2, condition3: !type2.condition3 })}
                        />
                        Stop не ниже предыдущего
                    </div>                   
                </Col>
            </Row>
        </>
    );
}

export default Type2;
